/* eslint-disable no-console */
/*
todo, investigar: 
>> ServiceWorker: Cannot read properties of undefined (reading 'pushManager')
la primera vez que se acepta el permiso de notificaciones
*/
import axios from 'axios';
import { initializeApp } from 'firebase/app';
import {
  getToken,
  getMessaging,
  onMessage,
  Messaging,
} from 'firebase/messaging';

import { GDTApiErrors } from '@/types';
import { axiosErrorHandler, isNativeApp, URLs } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

// const log = console.log.bind(console);
// var log = function () {}
// localStorage.setItem('enablePushNotificationsLogging', 'true');
const ENABLE_LOGGING =
  localStorage.getItem('enablePushNotificationsLogging') === 'true';

function log(level: 'error' | 'warn' | 'log' | 'debug', ...args: any[]) {
  if (process.env.NODE_ENV === 'development' || ENABLE_LOGGING) {
    console[level](...args);
  }
}

/*
-- Llamado por el sitio m.grandt.com.ar (antes del login)
-- Notificaciones web push.
-- Objetivos: 
-- 1) Recordar la decisión del usuario
-- 2) dejar en la cookie "fcmTKN" el token de FCM.

-- Luego del login se lee "fcmTKN" y se recuerda en GDT.
*/

const VAR_ACCION = 'FCM_ultima_accion';

enum eAccionEnum {
  RENOVACION_TOKEN = 'RENOVACION_TOKEN',
  RECHAZO_TEMPORAL_USUARIO = 'RECHAZO_USUARIO',
  DISMISS_POPUP = 'DISMISS_POPUP',
}

type eAccionValue = 'RENOVACION_TOKEN' | 'RECHAZO_USUARIO' | 'DISMISS_POPUP';

// console.log("rif")
let messaging: Messaging;

export async function runInitFirebase(
  fnCallback: (params: { askForPermission: boolean }) => void
) {
  if (!navigator.serviceWorker) {
    log('warn', 'SW no habilitado. ¿https?');
    return;
  }
  if (isNativeApp()) {
    // App nativa (Android/iOS), push no soportado desde webview (se maneja por fuera)
    log('warn', 'App nativa, apago firebase');
    return;
  }
  const theData = await getFcmConfiguration();
  log('debug', 'firebaseConfig_callback');
  const firebaseConfig = theData.firebaseConfig;
  if (!firebaseConfig) throw new Error('sin configuración??');

  navigator.serviceWorker
    .register('/firebase-messaging-sw.js', { scope: './' })
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    .then((_registration) => {
      /**
       * el scope default (/firebase-cloud-messaging-push-scope)
       * impide usar "navigator.serviceWorker.ready" (ver onMessage).
       * Por eso la registración manual.
       */
      const app = initializeApp(firebaseConfig);

      messaging = getMessaging(app);

      const accionReciente = getRecentUserAction();
      if (
        (!accionReciente || accionReciente === eAccionEnum.RENOVACION_TOKEN) &&
        Notification.permission === 'default'
      ) {
        // show html popup
        fnCallback({ askForPermission: true });
      }

      if (Notification.permission === 'granted') {
        // refresco el token de FCM (cada 20 días)
        refreshFirebaseToken();
      }

      if (Notification.permission === 'granted') {
        registerEventOnMessage();
      }
    });
}

async function debugPushNotifications() {
  const theData = await getFcmConfiguration();
  const firebaseConfig = theData.firebaseConfig;
  if (!firebaseConfig) throw new Error('sin configuración??');

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const _registration = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js',
    { scope: './' }
  );

  const app = initializeApp(firebaseConfig);
  messaging = getMessaging(app);
  const log = [];

  log.push('registro SW ok');
  log.push(
    `Le diste permisos al navegador?: ${Notification.permission === 'granted'}`
  );

  if (Notification.permission !== 'granted') {
    console.log(log.join('\n'));
    return log;
  }

  const { jwt: tokenAgea, idUsuarioFCM } = await getGDTAuthorizationForFCM();
  log.push(`autorización GDT ok, idUsuarioFCM: ${idUsuarioFCM}`);
  const logData = () => {
    return JSON.stringify({
      fcmTKN: localStorage.getItem('fcmTKN'),
      idUsuarioFCMLogueado: idUsuarioFCM,
      idUsuarioFCMRegistrado: localStorage.getItem('idUsuarioFCM'),
      accionReciente: getRecentUserAction(),
      lastLog: localStorage.getItem('fcm_log'),
    });
  };
  const responseDebug = await debugTokenAssociation(
    theData.urlBase,
    '' + localStorage.getItem('fcmTKN'),
    tokenAgea
  );
  log.push(
    `debugTokenAssociation:  ${JSON.stringify(responseDebug.extra, null, ' ')}`
  );

  const responseDebugAugmented = await debugAugmentedTokenAssociation(
    responseDebug.extra
  );
  if ('uuid' in responseDebugAugmented) {
    log.push(
      `con mails:  ${responseDebugAugmented.uuid} (ver logs en servidor con ese uuid)`
    );
  }
  if ('empty' in responseDebugAugmented && !responseDebugAugmented.empty) {
    log.push(
      `con mails (2):  ${JSON.stringify(responseDebugAugmented, null, ' ')}`
    );
  }

  log.push('vars: ' + logData());
  log.push(`lanzo un refresh del token de FCM...`);
  localStorage.setItem('idUsuarioFCM', '-');
  await refreshFirebaseToken();
  log.push('vars: ' + logData());
  console.log(log.join('\n'));
  return log;
}

window.debugPushNotifications = debugPushNotifications;

/**
 * Muestra una notificación cuando estamos en foreground.
 */
function registerEventOnMessage() {
  log('debug', 'registro onMessage ');
  onMessage(messaging, function (payload) {
    log('debug', 'Notificación con el sitio en foco y/o click', payload);
    if (!payload.notification) {
      log('debug', 'Payload sin notificación');
      return;
    }
    const options: NotificationOptions = {};
    const title = payload.notification.title || 'Gran DT';
    options.body = payload.notification.body;
    options.icon = payload.notification.icon;
    options.data = {
      fcmOptions: payload.fcmOptions,
    };
    navigator.serviceWorker.ready.then((registration) => {
      registration.showNotification(title || 'Gran DT', options);
    });
    log('debug', 'fin');
  });
}

/**
 * Setea token de Firebase en cookie "fcmTKN",
 * y continúa con registro en GDT si el usuario está logueado.
 */
async function refreshFirebaseToken() {
  const { jwt: tokenAgea, idUsuarioFCM } = await getGDTAuthorizationForFCM();
  /*
  const accionReciente = getRecentUserAction();
  if (
    idUsuarioFCM !== undefined &&
    accionReciente === eAccionEnum.RENOVACION_TOKEN &&
    idUsuarioFCM === localStorage.getItem('idUsuarioFCM')
  ) {
    log(
      'log',
      'skipping registration. mismo usuario, ya registrado:',
      idUsuarioFCM
    );
    return;
  } */
  let currentToken = '';
  try {
    currentToken = await getToken(messaging);
  } catch (err) {
    // error intentando recuperar el token
    log('warn', 'en getToken:', err);
    return;
  }

  if (currentToken) {
    if (!shouldUpdateTokenAssociation(currentToken, idUsuarioFCM)) {
      log(
        'log',
        'Sin cambios, evito reenviar asociación token-usuario al servidor'
      );
      return;
    }

    log('debug', 'token renovado ' + currentToken);
    rememberUserAction(eAccionEnum.RENOVACION_TOKEN);
    rememberTokenFcm(currentToken);

    const savedResponse = await saveTokenAssociation(tokenAgea, currentToken);
    if (savedResponse?.estado) {
      rememberAssociation(
        idUsuarioFCM,
        `${new Date().toLocaleString()} - asociación exitosa (${idUsuarioFCM} -- ${currentToken})`
      );
    }
    registerEventOnMessage();
  } else {
    // No Instance ID token available. Request permission to generate one
    log('warn', 'No token available. Request permission');
  }
}

/**
 * Recuerda qué decisión tomó el usuario en el popup HTML
 */
function rememberUserAction(strAccion: eAccionValue, idUsuarioFCM?: string) {
  const DIA = 1000 * 60 * 60 * 24;
  localStorage.setItem(`${VAR_ACCION}`, strAccion);
  let expirationMillis = new Date().getTime() + 20 * DIA;
  if (strAccion === eAccionEnum.DISMISS_POPUP) {
    expirationMillis = new Date().getTime() + 1 * DIA;
  } else if (strAccion === eAccionEnum.RENOVACION_TOKEN) {
    expirationMillis = new Date().getTime() + 2 * DIA;
  }
  localStorage.setItem(`${VAR_ACCION}__timestamp`, '' + expirationMillis);
  if (idUsuarioFCM) {
    localStorage.setItem(`idUsuarioFCM`, idUsuarioFCM);
  }
}
function rememberAssociation(idUsuarioFCM: string, log: string) {
  localStorage.setItem('idUsuarioFCM', idUsuarioFCM);
  if (log) {
    localStorage.setItem(`fcm_log`, log);
  }
}

export function rememberRejection() {
  rememberUserAction(eAccionEnum.RECHAZO_TEMPORAL_USUARIO);
}

export function rememberDismiss() {
  rememberUserAction(eAccionEnum.DISMISS_POPUP);
}

function getRecentUserAction() {
  // return null; // (x pruebas)
  const tmp = localStorage.getItem(`${VAR_ACCION}`);
  const dueDate = localStorage.getItem(`${VAR_ACCION}__timestamp`);
  if (!tmp || !dueDate || parseInt(dueDate, 10) < new Date().getTime())
    return null;
  return localStorage.getItem(`${VAR_ACCION}`);
}

/**
 * El confirm que ES NATIVO
 * solicitarPermisosRealmente
 */
export function reallyAskForPermissionNatively() {
  if (Notification.permission !== 'default') {
    // nada que hacer. Chrome no vuelve a preguntar.
    return;
  }
  Notification.requestPermission().then(function (response) {
    if (response === 'granted') {
      refreshFirebaseToken();
    }
  });
}

// ---------------------------------------------------------------------
// ------- utils -------------
// ---------------------------------------------------------------------

/**
 * fcm = Firebase Cloud Messaging
 */
function rememberTokenFcm(tokenFcm: string) {
  localStorage.setItem('fcmTKN', tokenFcm);
  localStorage.setItem('fcmTKN__timestamp', new Date().getTime().toString());
}

function readStoredTokenFcm() {
  return {
    fcmTKN: localStorage.getItem('fcmTKN'),
    timestamp: localStorage.getItem('fcmTKN__timestamp'),
  };
}

/*
 * Compara el token de FCM actual con el que se tiene guardado,
 * y también verifica si el idUsuarioFCM ha cambiado o si ha pasado más de un día desde la última actualización.
 * Si alguna de estas condiciones se cumple, devuelve true para indicar que se debe enviar el token al servidor.
 */
function shouldUpdateTokenAssociation(
  newFcmToken: string,
  newIdUsuarioFCM: string
) {
  const stored = readStoredTokenFcm();
  if (!stored.fcmTKN || !stored.timestamp) {
    return true;
  }
  const now = new Date().getTime();
  const timestamp = parseInt(stored.timestamp, 10);
  const diff = now - timestamp;
  const DIA = 1000 * 60 * 60 * 24;
  if (diff > DIA) {
    // Si han pasado más de un día, enviar el token al servidor
    return true;
  }
  if (stored.fcmTKN !== newFcmToken) {
    // Si el token ha cambiado, enviar el nuevo token al servidor
    return true;
  }
  const storedIdUsuarioFCM = localStorage.getItem('idUsuarioFCM');
  if (storedIdUsuarioFCM !== newIdUsuarioFCM) {
    // Si el idUsuarioFCM ha cambiado, enviar el nuevo token al servidor
    return true;
  }
  return false;
}

let responseFirebaseConfigCached: ResponseFirebaseConfigType;

// Extend Window interface to include responseFirebaseConfig
declare global {
  interface Window {
    responseFirebaseConfig?: ResponseFirebaseConfigType;
    debugPushNotifications?: () => Promise<string[]>;
  }
}

/**
 * <li>Ver /firebase-conf-test-var.js << test</li>
 * <li>Ver /firebase-conf-var.js << prod</li>
 * @returns {Promise<ResponseFirebaseConfigType>} - Devuelve la configuración de Firebase y otros datos necesarios.
 */
export async function getFcmConfiguration(): Promise<ResponseFirebaseConfigType> {
  if (responseFirebaseConfigCached) {
    return responseFirebaseConfigCached;
  }
  // Dynamically load the external config file
  await import(/* @vite-ignore */ `/firebase-conf${getEnv()}-var.js`);

  if (window.responseFirebaseConfig) {
    responseFirebaseConfigCached = window.responseFirebaseConfig;
  } else {
    throw new Error('Firebase configuration not found in window object');
  }

  return responseFirebaseConfigCached;
}

/**
 * Determina entorno
 * @returns {string} - retorna '-test' si es un entorno de test, vacío en caso contrario
 */
function getEnv() {
  const testUrls = [
    'localhost',
    'grandtpre-resp',
    'testgrandt-resp',
    'desagrandt',
  ];
  const esTest = testUrls.filter(function (elem) {
    return location.host.indexOf(elem) >= 0;
  }).length;
  return esTest ? '-test' : '';
}

/**
 * Asocia el token FCM (del dispositivo) con el usuario GDT (tokenAgea)
 * en la BD.
 */
const postTokenAssociation = axiosErrorHandler(
  async (urlBase: string, fcmToken: string, tokenAgea: string) => {
    const url = urlBase + 'expuestos/registrarUsuario';
    const params = { fcmToken };
    const axiosGdtFCM = axios.create({
      withCredentials: false,
      baseURL: urlBase,
    });

    const response = await axiosGdtFCM.post<GDTApiErrors>(url, params, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenAgea}`,
      },
    });
    if (response.status === 200) {
      return { estado: true, mensaje: '' };
    }
    return { estado: false, mensaje: `${url}: ${response.status}` };
  }
);

/**
 * Completa los emails.
 * Si es producción no los devuelve, loguea y devuelve un uuid para buscar el log.
 */
const debugAugmentedTokenAssociation = axiosErrorHandler(
  async (responseInicial: any) => {
    const url = URLs.PUSH_NOTIFICATIONS.DEBUG_COMPLETAR_LOGS;
    const response = await axiosGdt.post<GDTApiErrors | { uuid: string }>(
      url,
      responseInicial,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    const theData = await response.data;
    return theData;
  }
);

/**
 * Asocia el token FCM (del dispositivo) con el usuario GDT (tokenAgea)
 * en la BD.
 */
const debugTokenAssociation = axiosErrorHandler(
  async (urlBase: string, fcmToken: string, tokenAgea: string) => {
    let url = urlBase + 'expuestos/debug-usuario';
    url += `?fcmToken=${encodeURIComponent(fcmToken)}`;
    const axiosGdtFCM = axios.create({
      withCredentials: false,
      baseURL: urlBase,
    });

    const response = await axiosGdtFCM.get<GDTApiErrors>(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenAgea}`,
      },
    });
    if (response.status === 200) {
      return { estado: true, mensaje: 'data', extra: response.data };
    }
    return { estado: false, mensaje: `${url}: ${response.status}` };
  }
);

/** pide JWT a partir de sesión  */
const getGDTAuthorizationForFCM = axiosErrorHandler(async () => {
  const url = URLs.PUSH_NOTIFICATIONS.AUTHORIZE;

  const response = await axiosGdt.get<GDTApiErrors | AuthorizeResponse>(url);
  const theData = await response.data;
  if (!('jwt' in theData)) {
    throw new Error('sin autorización?');
  }
  return { jwt: theData.jwt, idUsuarioFCM: theData.idUsuarioFCM };
});

/**
 * Precondición: token FCM del dispositivo ya está en localStorage
 * <br>
 * Asocia el usuario GDT (tokenAgea) con dicho token.
 * Se llama desde notifyTokenFirebaseRecibido() cuando el usuario está logueado.
 */
async function saveTokenAssociation(tokenAgea: string, fcmToken: string) {
  if (!fcmToken) {
    return { estado: false, mensaje: 'sin token FCM' };
  }

  return getFcmConfiguration().then(async function (theData) {
    if (!theData.firebaseConfig) {
      return;
    }

    const result = await postTokenAssociation(
      theData.urlBase,
      fcmToken,
      tokenAgea
    );
    if (!result.estado) {
      log('error', 'Error al registrar usuario FCM:', result.mensaje);
    }
    return result;
  });
}

/*
async function notifyLoginGdt() {
function notifyTokenFirebaseReceived(
*/
